import { Heading, P } from '@salecycle/ui-component-library';
import { FC } from 'react';
import styled from 'styled-components';

const Header = styled.div`
  margin-bottom: 5rem;
`;

const Description = styled.div`
  margin-top: 3rem;
`;

export interface Props {
  heading: string;
  description1?: string;
  description2?: string;
  color?: string;
}

const LoginFormHeader: FC<Props> = ({ heading, description1, description2, color }) => (
  <Header>
    <Heading color={color} variation="h1">
      {heading}
    </Heading>

    {description1 && (
      <Description>
        <P color={color}>{description1}</P>
        {description2 && <P color={color}>{description2}</P>}
      </Description>
    )}
  </Header>
);

export default LoginFormHeader;
